/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Diagnosis from './Diagnosis/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconMonitorHeart from 'DesignSystem/Svgs/TysiaIconMonitorHeart/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/ActionsCell/DiagnosisAction/Content",
  hovered,
  onMouseEnter,
  onMouseLeave,
  onSubmit,
  disabled
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let createDiagnosisSubmitData = fromData.useDataSubmit({ viewPath,
context: 'create_diagnosis',
})
let eventAppointmentDiagnosisValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.diagnosis',
})
let eventAppointmentBookingStateValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.booking.state',
format: fromHelpers.isSeated,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 hovered={hovered}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 data={eventAppointmentDiagnosisValueData ? "event.appointment.booking.state" : "create_diagnosis"}
 onClick={createDiagnosisSubmitData}
 disabled={disabled}
 title={eventAppointmentDiagnosisValueData ? "Show diagnosis" : eventAppointmentBookingStateValueData ? "Create diagnosis" : "No diagnosis"}
 data={eventAppointmentDiagnosisValueData ? "event.appointment.booking.state" : "event.appointment.diagnosis"}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconMonitorHeart
{...childProps}
  viewPath={`${viewPath}/TysiaIconMonitorHeart`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</div>
<Diagnosis
  viewPath={`${viewPath}/Diagnosis`}
/>
{children}
</React.Fragment>)
}